export const VoiTheme = {
  name: 'Voi Theme',
  themeId: 'voi',
  colors: {
    brand: {
      primary: {
        100: '#497824'
      },
      secondary: {
        100: '#b4be00'
      },
      accent: {
        100: '#b4be00'
      },
      alternative: {
        100: '#497824'
      }
    }
  },
  backgrounds: {
    tile: 'linear-gradient(to right, #497824 0%, #b4be00 100%)'
  }
};